import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { IoIosGlobe } from "@react-icons/all-files/io/IoIosGlobe";
import {
  getSelectedFilters, onFilterSelect, getFestivalOptions
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import history from '../../../../history';


const FestivalFilter = props => {
  const dispatch = useDispatch();
  const filteredBookingOptions = useSelector(state => state.bookingOptions.filtered);
  const filteredYachts = useSelector(state => state.yachts.filtered);
  // find array of all weeks
  const allWeeks = props.weeks;
  const festivalOptions = getFestivalOptions(allWeeks);

  const selectedFestivalNames = festivalOptions.filter(festival => festival.weekIds.every(weekId => getSelectedFilters(history.location)[FILTERS.FESTIVAL].includes(`${weekId}`))).map(festival => festival.name);
  const selectedFilterText = selectedFestivalNames.join(', ');

  // function to check if option should be disabled
  // TODO: need to decide what we want - this approach is not allowing comparing multiple ones
  const isFestivalOptionDisabled =
    festivalOptions => filteredBookingOptions.every(bookingOption => !festivalOptions.includes(+bookingOption.week.id)) &&
    filteredYachts.every(yacht =>  !festivalOptions.includes(+yacht.week.id));

  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Routes</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {festivalOptions.map(item => (
          <Button key={JSON.stringify(item)} buttonType={selectedFestivalNames.includes(item.name) ? 'FILTER_ACTIVE' : 'FILTER'} onClick={() => item.weekIds.forEach(weekId => onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.FESTIVAL, weekId))}>{item.name}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoIosGlobe />}>{selectedFilterText || 'Routes'}</Button>;
};
FestivalFilter.propTypes = {
  mobile: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  filterAction: PropTypes.func.isRequired
};
export default FestivalFilter;
